/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";
import $ from "jquery";

interface Mode3DToggleOptions extends L.ControlOptions {
  /** Button text + tooltip — the mode it switches TO ("3D" on the 2D map). */
  label?: string;
}

// Standard leaflet-bar control that switches the map's 2D/3D mode. Mirrors
// ControlOverview: it only fires a map event ("custom_mode_toggle") and lets
// the consumer decide what switching means. Carries a short text label
// (centered via map.scss) instead of an icon.
const Mode3DToggleClass = (L.Control as any).extend({
  options: {
    position: "bottomright",
    label: "3D",
  } as Mode3DToggleOptions,

  onAdd: function (map: L.Map): HTMLElement {
    const a = $(
      '<div class="leaflet-control-mode-toggle leaflet-bar" title="' +
        this.options.label +
        '"><a role="button">' +
        this.options.label +
        "</a></div>"
    );
    a.on("click", function () {
      map.fire("custom_mode_toggle", {});
    });
    a.on("dblclick", function (e) {
      (e.originalEvent as Event)?.stopPropagation();
    });

    return a[0];
  },

  onRemove: function () {
    // Cleanup if needed
  },
});

export const Mode3DToggle = function (opts?: Mode3DToggleOptions): any {
  return new Mode3DToggleClass(opts);
};
